import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { paymentAPI } from '../../utils/api';
import { Alert, Spinner } from '../../components/ui';
import toast from 'react-hot-toast';

const STEPS = [
  { n:'1', icon:'📱', title:'Open UPI App', sub:'GPay, PhonePe, Paytm, BHIM' },
  { n:'2', icon:'💳', title:'Pay ₹499', sub:'to UPI ID below' },
  { n:'3', icon:'📋', title:'Copy UTR ID', sub:'From payment success screen' },
  { n:'4', icon:'✅', title:'Enter & Submit', sub:'Admin verifies in 24 hrs' },
];

export default function Payment() {
  const [params] = useSearchParams();
  const userId = params.get('user_id');
  const nav = useNavigate();
  const [utr, setUtr] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const copy = () => {
    navigator.clipboard.writeText('danarajmuthu28@okicici');
    toast.success('UPI ID copied!');
  };

  const submit = async () => {
    const clean = utr.trim();
    if (!clean || clean.length < 8) { setError('Please enter a valid UTR / Transaction ID (min 8 characters).'); return; }
    if (!userId) { setError('User ID missing. Please register again.'); return; }
    setLoading(true); setError('');
    try {
      await paymentAPI.submit(userId, clean);
      setDone(true);
      toast.success('Payment submitted! Awaiting verification.');
    } catch (e) { setError(e.response?.data?.message || 'Submission failed. Please try again.'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', background:'var(--bg)', fontFamily:'var(--font-body)' }}>
      {/* Navbar */}
      <nav style={{ background:'#fff', borderBottom:'1px solid var(--border)', padding:'0 5%', height:62, display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:100 }}>
        <Link to="/" style={{ fontFamily:'var(--font-heading)', fontSize:20, fontWeight:700, color:'var(--blue)', textDecoration:'none' }}>
          TNPSC <span style={{ color:'var(--gold)' }}>Hub</span>
        </Link>
        <div style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, color:'var(--muted)' }}>
          <span style={{ width:8, height:8, borderRadius:'50%', background:'var(--success)', display:'inline-block', animation:'pulse 1.5s ease-in-out infinite' }} />
          Secure Payment
        </div>
      </nav>

      <div style={{ maxWidth:1000, margin:'0 auto', padding:'44px 20px 80px', display:'grid', gridTemplateColumns:'1fr 1fr', gap:28, alignItems:'start' }} className="payment-grid">

        {/* ── UPI Card ── */}
        <div style={{ background:'linear-gradient(145deg,#060f2e,#0f2560,#1A3C8F)', borderRadius:24, padding:'40px 36px', position:'relative', overflow:'hidden', boxShadow:'0 28px 60px rgba(26,60,143,0.35)', animation:'fadeInUp 0.5s ease' }}>
          <div style={{ position:'absolute', width:400, height:400, background:'radial-gradient(circle,rgba(245,166,35,0.15),transparent 70%)', top:-100, right:-80, animation:'float 8s ease-in-out infinite', pointerEvents:'none' }} />
          <div style={{ position:'relative' }}>
            <div style={{ display:'inline-flex', alignItems:'center', gap:7, background:'rgba(245,166,35,0.15)', border:'1px solid rgba(245,166,35,0.35)', borderRadius:50, padding:'6px 16px', marginBottom:24, color:'var(--gold)', fontSize:11, fontWeight:700, letterSpacing:'1px', textTransform:'uppercase' }}>
              💰 One-Time Premium Access
            </div>
            <div style={{ textAlign:'center', marginBottom:28 }}>
              <div style={{ fontFamily:'var(--font-heading)', fontSize:52, fontWeight:900, color:'#fff', lineHeight:1 }}>
                <span style={{ fontSize:24, color:'var(--gold)', verticalAlign:'super', lineHeight:0 }}>₹</span>499
              </div>
              <div style={{ color:'rgba(255,255,255,0.4)', fontSize:13, marginTop:6 }}>All 4 Exam Groups · No Renewal</div>
            </div>

            {/* UPI QR Code */}
            <div style={{ textAlign:'center', marginBottom:24 }}>
              <div style={{ display:'inline-block', background:'#fff', borderRadius:16, padding:10, boxShadow:'0 12px 32px rgba(0,0,0,0.24)' }}>
                <img
                  src="https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=upi%3A%2F%2Fpay%3Fpa%3Ddanarajmuthu28%40okicici%26pn%3DTNPSC%2BHub%26am%3D499%26cu%3DINR%26tn%3DTNPSC%2BHub%2BPremium%2BAccess"
                  alt="UPI QR Code"
                  width={160}
                  height={160}
                  style={{ display:'block', borderRadius:8 }}
                />
              </div>
              <div style={{ fontSize:11, color:'rgba(255,255,255,0.45)', marginTop:8 }}>Scan with any UPI app to pay ₹499</div>
            </div>

            <div style={{ background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:12, padding:'14px 18px', marginBottom:10 }}>
              <div style={{ fontSize:9, color:'rgba(255,255,255,0.35)', letterSpacing:'1.2px', textTransform:'uppercase', marginBottom:6 }}>UPI ID</div>
              <div style={{ fontFamily:'var(--font-mono)', fontSize:17, fontWeight:700, color:'var(--gold)', letterSpacing:'0.5px' }}>danarajmuthu28@okicici</div>
            </div>
            <button onClick={copy} style={{ width:'100%', background:'rgba(245,166,35,0.12)', border:'1px solid rgba(245,166,35,0.3)', borderRadius:10, padding:10, color:'var(--gold)', fontFamily:'var(--font-body)', fontSize:13, fontWeight:700, cursor:'pointer', transition:'all 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.background='rgba(245,166,35,0.2)'}
              onMouseLeave={e => e.currentTarget.style.background='rgba(245,166,35,0.12)'}>
              📋 Copy UPI ID
            </button>

            {/* Steps */}
            <div style={{ marginTop:28, display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
              {STEPS.map(s => (
                <div key={s.n} style={{ background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.07)', borderRadius:10, padding:'12px 10px', textAlign:'center' }}>
                  <div style={{ fontSize:18, marginBottom:5 }}>{s.icon}</div>
                  <div style={{ fontSize:11, fontWeight:700, color:'rgba(255,255,255,0.7)', marginBottom:2 }}>{s.title}</div>
                  <div style={{ fontSize:10, color:'rgba(255,255,255,0.3)' }}>{s.sub}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── UTR Form ── */}
        <div className="card" style={{ animation:'fadeInUp 0.6s ease' }}>
          {!done ? (
            <div className="card-body" style={{ padding:36 }}>
              <h3 style={{ fontFamily:'var(--font-heading)', fontSize:24, marginBottom:8 }}>Enter Payment Details</h3>
              <p style={{ color:'var(--muted)', fontSize:13, lineHeight:1.7, marginBottom:28 }}>
                After completing the UPI payment, enter your UTR/Transaction Reference ID for verification.
              </p>

              <div style={{ background:'rgba(245,166,35,0.05)', border:'1px solid rgba(245,166,35,0.2)', borderRadius:12, padding:'14px 16px', marginBottom:24 }}>
                <div style={{ fontSize:12, fontWeight:700, color:'var(--gold-dark)', marginBottom:8 }}>📍 Where to find UTR ID?</div>
                {[['GPay','Transaction Details → UPI Reference ID'],['PhonePe','History → Transaction ID'],['Paytm','Transaction History → UTR Number'],['BHIM','Transaction Details → Reference No']].map(([app,loc]) => (
                  <div key={app} style={{ display:'flex', gap:8, marginBottom:5, fontSize:12 }}>
                    <span style={{ color:'var(--gold-dark)', fontWeight:700, width:56, flexShrink:0 }}>{app}</span>
                    <span style={{ color:'var(--muted)' }}>{loc}</span>
                  </div>
                ))}
              </div>

              {error && <Alert type="error" onClose={() => setError('')}>{error}</Alert>}

              <div className="form-group">
                <label className="form-label">UTR / Transaction Reference ID <span className="req">*</span></label>
                <input
                  className="form-input no-icon"
                  style={{ fontFamily:'var(--font-mono)', fontSize:16, fontWeight:700, letterSpacing:1, height:52 }}
                  placeholder="e.g. 427812345678"
                  maxLength={30}
                  value={utr}
                  onChange={e => setUtr(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && submit()}
                />
                <span style={{ fontSize:11, color:'var(--muted)', marginTop:5, display:'block' }}>12-digit number found in your UPI app after successful payment</span>
              </div>

              <button className="btn btn-gold btn-lg btn-full" style={{ marginTop:8 }} onClick={submit} disabled={loading}>
                {loading ? <><Spinner size={17} color="white" /> Submitting...</> : '✅ Submit & Proceed'}
              </button>

              <div style={{ marginTop:16, padding:'12px 14px', background:'var(--bg)', borderRadius:10, border:'1px solid var(--border)', fontSize:12, color:'var(--muted)', textAlign:'center' }}>
                Need help? Call <a href="tel:9443724724" style={{ color:'var(--blue)', fontWeight:700 }}>9443724724</a> or email <a href="mailto:support@tnpschub.msdiscoveries.com" style={{ color:'var(--blue)', fontWeight:700 }}>support@tnpschub.msdiscoveries.com</a>
              </div>
            </div>
          ) : (
            <div style={{ padding:'52px 36px', textAlign:'center', animation:'scaleIn 0.4s ease' }}>
              <div style={{ width:80, height:80, borderRadius:'50%', background:'rgba(40,167,69,0.1)', border:'3px solid var(--success)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:36, margin:'0 auto 20px' }}>✅</div>
              <h3 style={{ fontFamily:'var(--font-heading)', fontSize:26, color:'var(--success)', marginBottom:10 }}>Payment Submitted!</h3>
              <p style={{ color:'var(--muted)', fontSize:14, lineHeight:1.75, marginBottom:10 }}>
                Your UTR ID has been received. Our admin will verify and activate your account within <strong>24 hours</strong>.
              </p>
              <p style={{ color:'var(--muted)', fontSize:13, marginBottom:32 }}>You'll receive a confirmation email at <strong>{params.get('email') || 'your email'}</strong>.</p>
              <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                <Link to="/login" className="btn btn-primary btn-lg">→ Go to Login</Link>
                <Link to="/" className="btn btn-outline btn-sm">Back to Home</Link>
              </div>
            </div>
          )}
        </div>

      </div>
      <style>{`
        @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-14px)}}
        @keyframes pulse{0%,100%{opacity:1}50%{opacity:0.4}}
        @keyframes scaleIn{from{opacity:0;transform:scale(0.94)}to{opacity:1;transform:scale(1)}}
        .payment-grid{grid-template-columns:1fr 1fr}
        @media(max-width:768px){.payment-grid{grid-template-columns:1fr!important}}
      `}</style>
    </div>
  );
}
